import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, FileText, Mail, UserCog, Bell, Type, CreditCard, Clock } from 'lucide-react';
import { Card } from '../components/ui/Card';
export function AdminArea() {
  const menuItems = [{
    label: 'Edit Static Pages',
    href: '/static-pages',
    icon: FileText
  }, {
    label: 'Change Email Details',
    href: '/email-details',
    icon: Mail
  }, {
    label: 'Edit User Profile Custom Fields',
    href: '/custom-fields',
    icon: UserCog
  }, {
    label: 'Edit E-mail Notifications',
    href: '/notifications',
    icon: Bell
  }, {
    label: 'Edit direction text',
    href: '/direction-text',
    icon: Type
  }, {
    label: 'Manage credit types',
    href: '/credit-types',
    icon: CreditCard
  }, {
    label: 'Switch Expired Class',
    href: '/switch-expired',
    icon: Clock
  }];
  return <div className="space-y-6" data-id="element-296">
      <h1 className="text-2xl font-bold text-slate-900" data-id="element-297">Admin Area</h1>

      <Card className="divide-y divide-slate-200" data-id="element-298">
        {menuItems.map(item => <Link key={item.label} to={item.href} className="flex items-center justify-between p-4 hover:bg-slate-50 transition-colors group" data-id="element-299">
            <div className="flex items-center gap-4" data-id="element-300">
              <div className="h-10 w-10 rounded-full bg-slate-100 flex items-center justify-center group-hover:bg-white group-hover:shadow-sm transition-all" data-id="element-301">
                <item.icon className="h-5 w-5 text-slate-600" data-id="element-302" />
              </div>
              <span className="font-medium text-slate-900" data-id="element-303">{item.label}</span>
            </div>
            <ChevronRight className="h-5 w-5 text-slate-400 group-hover:text-slate-600" data-id="element-304" />
          </Link>)}
      </Card>
    </div>;
}